module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_search-e0d710201bfdc3f994fdf76a2f9cabfd.svg";